import $ from 'jquery';

const selectors = {
  slider: '[data-slider]',
  photo: '[data-grid-slide]',
};

const attributes = {
  showDots: 'data-show-dots',
  groupCells: 'data-group-cells',
};

const sections = {};

class Slider {
  constructor(container, el) {
    this.container = container;
    this.slideshow = el;

    if (!this.slideshow) return;

    this.init();
  }

  init() {
    const $slideshow = $(this.slideshow);
    $slideshow.slick();
    const tabsHolder = this.container.querySelectorAll('[data-tabs-holder]');
    tabsHolder.forEach((el) => el.addEventListener('theme:tab:change', () => {
      console.log('theme:tab:change')
      setTimeout(() => {
        $slideshow.slick('setPosition');
      }, 10);
      })
    );
  }

  removeIncorrectAria() {
    const slidesHidden = this.slideshow.querySelectorAll('[aria-hidden="true"]');
    slidesHidden.forEach((el) => el.removeAttribute('aria-hidden'));
  }

  onUnload() {
    // if (this.slideshow && this.flkty) {
    //   this.flkty.options.watchCSS = false;
    //   this.flkty.destroy();
    // }
  }
}

const productSliderSection = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.slider);
    els.forEach((el) => {
      sections[this.id].push(new Slider(this.container, el));
    });
  },
  onUnload(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onUnload === 'function') {
        el.onUnload(e);
      }
    });
  },
};

export {productSliderSection, Slider};
